import { render, staticRenderFns } from "./AddressPanel.vue?vue&type=template&id=7668a25c&scoped=true&"
import script from "./AddressPanel.vue?vue&type=script&lang=js&"
export * from "./AddressPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddressPanel.vue?vue&type=style&index=0&id=7668a25c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668a25c",
  null
  
)

export default component.exports